import styled from "styled-components";
import {device} from "src/theme/theme";

export const Paragraph = styled.p`
  color: ${p => p.color};
  ${({ theme }) => ({ ...theme.size.sm })};

  &.question {
    color: ${p => p.theme.colors.secondaryBackgroundColor};
    margin-top: 1rem;
  }

  @media ${device.tablet} {
    max-width: 75%;
  }
`

export const Content = styled.div`
  padding: 1rem 0 3.75rem;
`;
